import React from 'react';
import { Button } from '../../../../../atoms';
import { Typography } from '../../../../../electrons';
import { ButtonGroup } from '../../../../ButtonGroup/ButtonGroup';
import { QR_CODE_SETTINGS_DEFAULTS } from '../../../constants/QrCodeSettingsDefaults';
import { useFinderPatternService } from '../../../hooks/useFinderPatternService/useFinderPatternService';
import { Circle } from '../../icons/Circle';
import { RoundedSquare } from '../../icons/RoundedSquare';
import { Square } from '../../icons/Square';
import { FinderPatternStyles } from './FinderPattern.styles';
const FinderPattern = (props) => {
    const { finderPattern = QR_CODE_SETTINGS_DEFAULTS.finder_pattern, onFinderPatternChange } = props;
    const finderPatternService = useFinderPatternService({
        finderPattern,
        onFinderPatternChange,
    });
    return (React.createElement("div", null,
        React.createElement(Typography, { variant: "subtitle1", className: FinderPatternStyles.text }, "Finder Style"),
        React.createElement(ButtonGroup, { variant: "outlined", color: "inherit" },
            React.createElement(Button, { id: "finder-style-button-1", className: FinderPatternStyles.button, variant: finderPatternService.handleButtonVariant(1), color: finderPatternService.handleButtonColor(1), onClick: () => finderPatternService.handleOnClick(1) },
                React.createElement(Square, { borderColor: finderPatternService.handleBorderColor(1) })),
            React.createElement(Button, { id: "finder-style-button-2", className: FinderPatternStyles.button, variant: finderPatternService.handleButtonVariant(2), color: finderPatternService.handleButtonColor(2), onClick: () => finderPatternService.handleOnClick(2) },
                React.createElement(RoundedSquare, { borderColor: finderPatternService.handleBorderColor(2) })),
            React.createElement(Button, { id: "finder-style-button-3", className: FinderPatternStyles.button, variant: finderPatternService.handleButtonVariant(3), color: finderPatternService.handleButtonColor(3), onClick: () => finderPatternService.handleOnClick(3) },
                React.createElement(Circle, { borderColor: finderPatternService.handleBorderColor(3) })))));
};
export default FinderPattern;
//# sourceMappingURL=FinderPattern.js.map